const ComplianceEcoVadis = () => {
  return "compliance eco vadis not implemented";
};
export default ComplianceEcoVadis;
